import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth.interceptor';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { TranslateLibModule } from '@kinomap-dev/ng-ui-lib/core';
import { routes } from 'app/app.routes';
import {
  MOCK_CONTEST_API_CONFIG,
  MockContestApiService,
} from './features/contest/data-access/api/mock-contest-api.service';
import { ContestApi } from './features/contest/data-access/api/contest-api.types';
import { ContestApiService } from './features/contest/data-access/api/contest-api.service';

const USE_MOCK_CONTEST_API: boolean = false;

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: MOCK_CONTEST_API_CONFIG,
      useValue: { addUserEveryMs: 5000, initialUsers: 300, latencyMs: 200 },
    },
    {
      provide: ContestApi,
      useClass: USE_MOCK_CONTEST_API ? MockContestApiService : ContestApiService,
    },
    DatePipe,
    importProvidersFrom(TranslateLibModule.forRoot()),
  ],
};
